export default __webpack_public_path__ + "42c30f2f04a701eb79387203352006aa.png";